import AppRoutes from "./routes";
import "./App.scss";
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import OrbLoading from "./shared/components/orb-loading";
import "./i18n"
import { ToastContainer } from "react-toastify";
import { io } from 'socket.io-client';
import { useEffect } from 'react'
import socket from "./utils/socket";
import logo from './asset/planet-links.png'

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error: any) => {
      if (error.request) {
        // handle network error here
      }
    },
  }),
});

function App() {

  // useEffect(() => {

  //   if (Notification.permission !== "granted") {
  //     Notification.requestPermission();
  //   }

  //   socket.on("notification", (data) => {
  //     if (Notification.permission === "granted") {
  //       new Notification("New Notification", {
  //         body: data.body || "You have a new event",
  //         icon: logo
  //       });
  //     }
  //   });

  //   return () => {
  //     socket.off("notification");
  //   };
  // }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <OrbLoading />
      <ToastContainer />
      <AppRoutes />
    </QueryClientProvider>
  );
}
export default App;
